import { InputAdornment, SxProps, TextField, Theme } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

interface SimpleSearchInputProps {
  height?: number;
  size?: "small" | "medium";
  value?: string;
  onChange?: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  placeholder?: string;
  variant?: "standard" | "filled" | "outlined" | undefined;
  focused?: boolean | undefined;
  onClear?: () => void;
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  closable?: boolean;
}
export default function SimpleSearchInput({
  height,
  size,
  value,
  onChange,
  placeholder,
  variant,
  focused,
  onClear,
  sx,
  fullWidth,
  closable,
}: SimpleSearchInputProps) {
  return (
    <>
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        variant={variant}
        focused={focused}
        size={size}
        fullWidth={fullWidth}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {value || closable ? (
                <ClearIcon
                  onClick={onClear}
                  color={value ? "primary" : "inherit"}
                  sx={{ cursor: "pointer" }}
                />
              ) : (
                <SearchIcon color={value ? "primary" : "inherit"} />
              )}
            </InputAdornment>
          ),
        }}
        sx={{
          height: height ? `${height}px` : "unset",
          "& .MuiOutlinedInput-root": {
            height: height ? `${height}px` : "unset",
          },
          ...(sx || {}),
        }}
      />
    </>
  );
}
